const jQuery = require('jquery');

const ThemeRTE = require('@shopify/theme-rte');

const rteWrappers = function rteWrappers() {
  // Target tables to make them scrollable
  const tableSelectors = '.rte table';

  ThemeRTE.wrapTable({
    $tables: jQuery(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  const iframeSelectors = '.rte iframe[src*="youtube.com/embed"],' + '.rte iframe[src*="player.vimeo"]';

  ThemeRTE.wrapIframe({
    $iframes: jQuery(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper',
  });
};

exports.default = rteWrappers;
